import { Activity, useEffect, useState } from 'react'
import HeaderEmbed from '@common/HeaderEmbed'
import '@common/reset.css'
import './style.scss'
import { formatNumeric } from '@common/utils'

export default function App({ className, preview, embedHome }) {
	const [premis, setPremis] = useState(null)

	useEffect(() => {
		fetch(`${process.env.API_CLIENT}/embeds/v1/loteria-nadal`)
			.then((res) => res.json())
			.then((json) => setPremis(json.data))
			.catch((error) => console.log(error))
	}, [])

	if (!premis) return null

	return (
		<>
			<Activity mode={preview ? 'visible' : 'hidden'}>
				<HeaderEmbed allowHomeEmbed />
			</Activity>
			<div className={`content ${className || ''}`}>
				<div className='cap'>
					<p className='l1 up'>La rifa de Nadal</p>
					<p className='l3'>
						<Activity mode={premis.link_noticia !== '' && embedHome ? 'visible' : 'hidden'}>
							<a href={premis.link_noticia} target='_blank'>
								Comprova el teu número{' '}
								<svg
									xmlns='http://www.w3.org/2000/svg'
									height='15px'
									viewBox='0 -960 960 960'
									width='15px'
									fill='#000'
								>
									<path d='m700-300-57-56 84-84H120v-80h607l-83-84 57-56 179 180-180 180Z' />
								</svg>
							</a>
						</Activity>
					</p>
				</div>
				<div className='premis'>
					<div className='premi premi1'>
						<p className='l2'>Primer premi</p>
						<p className='l3'>4.000.000&euro;</p>
						<ul className='p1'>
							<li className='l4'>{formatNumeric(premis.primer_premi)}</li>
						</ul>
					</div>
					<div className='premi premi2'>
						<p className='l2'>Segon premi</p>
						<p className='l3'>1.250.000&euro;</p>
						<ul className='p2'>
							<li className='l4'>{formatNumeric(premis.segon_premi)}</li>
						</ul>
					</div>
					<div className='premi premi3'>
						<p className='l2'>Tercer premi</p>
						<p className='l3'>500.000&euro;</p>
						<ul className='p3'>
							<li className='l4'>{formatNumeric(premis.tercer_premi)}</li>
						</ul>
					</div>
					<div className='premi premi4'>
						<p className='l2'>Quarts premis</p>
						<p className='l3'>200.000&euro;</p>
						<ul>
							<li className='l5'>{formatNumeric(premis.quart_premi1)}</li>
							<li className='l5'>{formatNumeric(premis.quart_premi2)}</li>
						</ul>
					</div>
					<div className='premi premi5'>
						<p className='l2'>Cinquens premis</p>
						<p className='l3'>60.000&euro;</p>
						<ul>
							<li className='l5'>{formatNumeric(premis.cinque_premi1)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi2)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi3)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi4)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi5)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi6)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi7)}</li>
							<li className='l5'>{formatNumeric(premis.cinque_premi8)}</li>
						</ul>
					</div>
				</div>
			</div>
		</>
	)
}
